import { useGasFee } from "../contexts/gasFee";

/**
 * Hook to get estimated gas fee
 * @returns {Object} Object containing gasFee, loading, error, refetch, and isStale
 * 
 * @example
 * const { gasFee, loading, error, refetch } = useEstimatedGasFee();
 */
export const useEstimatedGasFee = () => {
  const { gasFee, nativeBalance, sgtBalance, stakePlans, loading, error, refetch, isStale } = useGasFee();
  
  return { 
    gasFee, 
    nativeBalance,
    sgtBalance,
    stakePlans,
    loading, 
    error, 
    refetch,
    isStale 
  };
};

